import {Component, Input, OnInit} from '@angular/core';
import {RatingDetails, SingleRatingPageService} from "../../services/single-rating-page.service";

@Component({
  selector: 'app-single-rating-page',
  templateUrl: './single-rating-page.component.html',
  styleUrls: ['./single-rating-page.component.scss']
})
export class SingleRatingPageComponent implements OnInit {

  @Input() isStaff;
  constructor(
    private singleRatingPageService: SingleRatingPageService
  ) { }

  ngOnInit(): void {
    this.singleRatingPageService.isStaff = this.isStaff === 'True';
    const searchParameters = new URLSearchParams(window.location.search);
    this.singleRatingPageService.ratingId = +searchParameters.get('detailsId');
    this.singleRatingPageService.getCertainRatingDetail().subscribe((response: RatingDetails) => {
      this.singleRatingPageService.parseResponse(response);
    });
  }

}
